import type { Promotion } from "./promo_defs";
import { createStore } from "@virgodev/vue-models/utils/create_store";

export const usePromotionsStore = createStore<Promotion>('promotions')